// Quiz data: generated from the tested role profiles. Do not edit the scores or the nudge by hand.
// Each answer gives its main trait 2 points and its minor trait 1 point.
// 'nudge' is a small hidden adjustment found by simulation, so that no role is over- or under-picked.
export const TRAITS = ["Daring", "Romantic", "Mischievous", "Principled", "Dramatic", "Dry wit", "Loyal", "Ambitious", "Ruthless"];

// The most points a person can score on each trait, used to put every trait on the same scale.
export const MAXES = {"Daring": 15, "Romantic": 11, "Mischievous": 16, "Principled": 16, "Dramatic": 16, "Dry wit": 13, "Loyal": 15, "Ambitious": 16, "Ruthless": 12};

export const QUESTIONS = [
  {
    "text": "The group chat is planning a night out. You are...",
    "answers": [
      {
        "text": "Already booking the table, making the playlist and giving everyone a job.",
        "main": "Ambitious",
        "minor": "Ruthless"
      },
      {
        "text": "Suggesting the one thing nobody has tried. \"It will be fine.\"",
        "main": "Daring",
        "minor": "Mischievous"
      },
      {
        "text": "Checking everyone has eaten and has a way home.",
        "main": "Loyal",
        "minor": "Principled"
      },
      {
        "text": "Typing \"I'm easy\" while quietly vetoing everything.",
        "main": "Dry wit",
        "minor": "Ruthless"
      }
    ]
  },
  {
    "text": "Your phone goes off in the quietest scene of the night. You...",
    "answers": [
      {
        "text": "Blame the person next to you, without blinking.",
        "main": "Ruthless",
        "minor": "Mischievous"
      },
      {
        "text": "Apologise to the whole row, with a small bow and a hand on your heart.",
        "main": "Dramatic",
        "minor": "Romantic"
      },
      {
        "text": "Whisper \"sorry\" and save the joke for the interval.",
        "main": "Dry wit",
        "minor": "Mischievous"
      },
      {
        "text": "Silence it, sit up very straight and vow never to be that person again.",
        "main": "Principled",
        "minor": "Ambitious"
      }
    ]
  },
  {
    "text": "A stranger is sitting in your seat. You...",
    "answers": [
      {
        "text": "Politely ask them to check their ticket, and show yours.",
        "main": "Principled",
        "minor": "Dry wit"
      },
      {
        "text": "Sit in theirs and see how long it takes them to notice.",
        "main": "Mischievous",
        "minor": "Daring"
      },
      {
        "text": "Make a short, moving speech about the importance of seat numbers.",
        "main": "Dramatic",
        "minor": "Principled"
      },
      {
        "text": "Notice their seat is better, and negotiate a swap.",
        "main": "Ambitious",
        "minor": "Ruthless"
      }
    ]
  },
  {
    "text": "It is a free Saturday. Your perfect plan is...",
    "answers": [
      {
        "text": "Spontaneous. Someone says \"let's go\" and you are already at the station.",
        "main": "Daring",
        "minor": "Romantic"
      },
      {
        "text": "A long, lovely day somewhere pretty with your favourite person.",
        "main": "Romantic",
        "minor": "Loyal"
      },
      {
        "text": "Hosting: snacks, games, a ridiculous theme, everyone in costume.",
        "main": "Dramatic",
        "minor": "Mischievous"
      },
      {
        "text": "Quietly making progress on the project that will make you famous.",
        "main": "Ambitious",
        "minor": "Principled"
      }
    ]
  },
  {
    "text": "Your best friend asks for honest feedback on a very bad idea. You...",
    "answers": [
      {
        "text": "Tell them the truth, kindly, because that is what friends do.",
        "main": "Principled",
        "minor": "Loyal"
      },
      {
        "text": "Suggest making it ten times bigger and more ridiculous.",
        "main": "Mischievous",
        "minor": "Daring"
      },
      {
        "text": "Say \"I love it\" and help them do it anyway.",
        "main": "Loyal",
        "minor": "Romantic"
      },
      {
        "text": "Say you are in, then quietly take over and improve it.",
        "main": "Ruthless",
        "minor": "Ambitious"
      }
    ]
  },
  {
    "text": "Someone hands you a stage and five minutes. You...",
    "answers": [
      {
        "text": "Sing. Obviously. With a key change.",
        "main": "Dramatic",
        "minor": "Romantic"
      },
      {
        "text": "Wander into the audience and borrow at least one person's drink.",
        "main": "Mischievous",
        "minor": "Daring"
      },
      {
        "text": "Deliver a deadpan speech: \"I'll keep it brief. I won't.\"",
        "main": "Dry wit",
        "minor": "Dramatic"
      },
      {
        "text": "Announce your plan for quietly taking over the industry. There are slides.",
        "main": "Ambitious",
        "minor": "Ruthless"
      }
    ]
  },
  {
    "text": "What is your signature move at a party?",
    "answers": [
      {
        "text": "Finding the person standing alone and making them feel welcome.",
        "main": "Loyal",
        "minor": "Principled"
      },
      {
        "text": "Telling a story that gets bigger every time.",
        "main": "Dramatic",
        "minor": "Mischievous"
      },
      {
        "text": "Being first on the dance floor, whatever is playing.",
        "main": "Daring",
        "minor": "Dramatic"
      },
      {
        "text": "Finding one person you click with and talking until the lights come on.",
        "main": "Romantic",
        "minor": "Dry wit"
      }
    ]
  },
  {
    "text": "You find out something juicy about someone who has been unkind to you. You...",
    "answers": [
      {
        "text": "Keep it to yourself. Being the bigger person is a power move.",
        "main": "Principled",
        "minor": "Ambitious"
      },
      {
        "text": "Mention it casually at exactly the right moment.",
        "main": "Ruthless",
        "minor": "Ambitious"
      },
      {
        "text": "Tell your best friend at once, for strictly emotional reasons.",
        "main": "Loyal",
        "minor": "Dramatic"
      },
      {
        "text": "Feel a sudden pang of sympathy and send them a kind message.",
        "main": "Romantic",
        "minor": "Principled"
      }
    ]
  },
  {
    "text": "Pick the perfect love story ending.",
    "answers": [
      {
        "text": "A sunrise, a train platform and someone running towards you.",
        "main": "Romantic",
        "minor": "Dramatic"
      },
      {
        "text": "Two rivals realise they have been arguing because they are perfect for each other.",
        "main": "Dry wit",
        "minor": "Romantic"
      },
      {
        "text": "A grand gesture so big that the next county hears about it.",
        "main": "Daring",
        "minor": "Romantic"
      },
      {
        "text": "A quiet, steady partnership where you both turn out to be brilliant.",
        "main": "Loyal",
        "minor": "Ambitious"
      }
    ]
  },
  {
    "text": "You are given an impossible deadline. You...",
    "answers": [
      {
        "text": "Rally everyone, split the work and take charge.",
        "main": "Ambitious",
        "minor": "Loyal"
      },
      {
        "text": "Panic beautifully for ten minutes, then pull it off at 3am.",
        "main": "Dramatic",
        "minor": "Daring"
      },
      {
        "text": "Find a loophole. There is always a loophole.",
        "main": "Mischievous",
        "minor": "Ruthless"
      },
      {
        "text": "Do it properly, even if it is late, and explain why.",
        "main": "Principled",
        "minor": "Dry wit"
      }
    ]
  },
  {
    "text": "Someone offers you a shortcut that bends the rules slightly. You...",
    "answers": [
      {
        "text": "Take it. You read the small print, and you are within it.",
        "main": "Ruthless",
        "minor": "Mischievous"
      },
      {
        "text": "Decline. You would have to live with yourself.",
        "main": "Principled",
        "minor": "Loyal"
      },
      {
        "text": "Take it, and bring a friend, because shortcuts are better in pairs.",
        "main": "Mischievous",
        "minor": "Loyal"
      },
      {
        "text": "Take it, with a wink and a small dance.",
        "main": "Daring",
        "minor": "Dramatic"
      }
    ]
  },
  {
    "text": "How would your friends describe you in one line?",
    "answers": [
      {
        "text": "\"Says what everyone else is thinking.\"",
        "main": "Dry wit",
        "minor": "Daring"
      },
      {
        "text": "\"Has a plan, and the plan has a plan.\"",
        "main": "Ambitious",
        "minor": "Principled"
      },
      {
        "text": "\"Would cross a motorway for you, then complain about it.\"",
        "main": "Loyal",
        "minor": "Dry wit"
      },
      {
        "text": "\"Never a dull moment. Sometimes too many moments.\"",
        "main": "Mischievous",
        "minor": "Dramatic"
      }
    ]
  }
];

export const ROLES = [
 {
  "role": "Elphaba",
  "show": "Wicked",
  "dbShow": "Wicked",
  "scores": {
   "Daring": 5,
   "Principled": 5,
   "Loyal": 4,
   "Ambitious": 3,
   "Dramatic": 3
  },
  "line": "You were told to tone it down once. You did not, and the whole country noticed.",
  "nudge": 0.0994
 },
 {
  "role": "Glinda",
  "show": "Wicked",
  "dbShow": "Wicked",
  "scores": {
   "Dramatic": 5,
   "Ambitious": 5,
   "Loyal": 4,
   "Mischievous": 3,
   "Romantic": 3
  },
  "line": "You light up every room, and you have a plan for it. It is also slightly pink.",
  "nudge": -0.0511
 },
 {
  "role": "Fiyero",
  "show": "Wicked",
  "dbShow": "Wicked",
  "scores": {
   "Romantic": 4,
   "Mischievous": 4,
   "Daring": 4,
   "Dry wit": 2
  },
  "line": "You do not have a plan. You have a smile, and so far it has worked.",
  "nudge": -0.1688
 },
 {
  "role": "Madame Morrible",
  "show": "Wicked",
  "dbShow": "Wicked",
  "scores": {
   "Ambitious": 5,
   "Ruthless": 5,
   "Dramatic": 4,
   "Dry wit": 3,
   "Mischievous": 2
  },
  "line": "You call it leadership. Everyone else calls it a power trip.",
  "nudge": -0.0553
 },
 {
  "role": "Simba",
  "show": "The Lion King",
  "dbShow": "The Lion King",
  "scores": {
   "Loyal": 4,
   "Daring": 4,
   "Principled": 3,
   "Mischievous": 3,
   "Romantic": 3
  },
  "line": "You avoided your problems for a good while. Then you went back for them, and that counts.",
  "nudge": -0.0353
 },
 {
  "role": "Nala",
  "show": "The Lion King",
  "dbShow": "The Lion King",
  "scores": {
   "Daring": 5,
   "Loyal": 5,
   "Principled": 4,
   "Dry wit": 3
  },
  "line": "You saw the problem first, said so loudly, and were right.",
  "nudge": 0.1937
 },
 {
  "role": "Scar",
  "show": "The Lion King",
  "dbShow": "The Lion King",
  "scores": {
   "Ruthless": 5,
   "Dry wit": 5,
   "Ambitious": 5,
   "Dramatic": 4,
   "Mischievous": 3
  },
  "line": "Your plan is flawless, and you will explain it at length. Mind the hyenas.",
  "nudge": -0.0071
 },
 {
  "role": "Rafiki",
  "show": "The Lion King",
  "dbShow": "The Lion King",
  "scores": {
   "Mischievous": 4,
   "Dry wit": 4,
   "Dramatic": 4,
   "Loyal": 3,
   "Principled": 3
  },
  "line": "You know exactly what is going on, and you will not say it plainly.",
  "nudge": 0.0408
 },
 {
  "role": "Alexander Hamilton",
  "show": "Hamilton",
  "dbShow": "Hamilton",
  "scores": {
   "Ambitious": 5,
   "Daring": 4,
   "Dramatic": 4,
   "Principled": 3,
   "Dry wit": 3
  },
  "line": "You have written three opinions this week already, and you are not done.",
  "nudge": 0.1251
 },
 {
  "role": "Aaron Burr",
  "show": "Hamilton",
  "dbShow": "Hamilton",
  "scores": {
   "Dry wit": 4,
   "Ambitious": 4,
   "Principled": 3,
   "Dramatic": 2
  },
  "line": "You wait for the right moment. A lot of other people are not waiting at all.",
  "nudge": 0.0442
 },
 {
  "role": "Eliza Hamilton",
  "show": "Hamilton",
  "dbShow": "Hamilton",
  "scores": {
   "Loyal": 5,
   "Romantic": 5,
   "Principled": 4,
   "Ambitious": 2
  },
  "line": "You gave your whole heart, and you kept excellent records.",
  "nudge": -0.1366
 },
 {
  "role": "King George III",
  "show": "Hamilton",
  "dbShow": "Hamilton",
  "scores": {
   "Dramatic": 5,
   "Dry wit": 5,
   "Mischievous": 4,
   "Ruthless": 3,
   "Romantic": 3
  },
  "line": "You treat every break-up as a full stage show. At least the costumes are good.",
  "nudge": -0.1182
 },
 {
  "role": "Catherine of Aragon",
  "show": "SIX",
  "dbShow": "SIX the Musical",
  "scores": {
   "Principled": 5,
   "Loyal": 5,
   "Dramatic": 3,
   "Dry wit": 2
  },
  "line": "You do not do drama, you do dignity. You are quietly furious, and it is spectacular.",
  "nudge": 0.0317
 },
 {
  "role": "Anne Boleyn",
  "show": "SIX",
  "dbShow": "SIX the Musical",
  "scores": {
   "Mischievous": 5,
   "Dramatic": 5,
   "Daring": 4,
   "Dry wit": 4
  },
  "line": "You are the life of the party, and the party has opinions about you.",
  "nudge": 0.0224
 },
 {
  "role": "Jane Seymour",
  "show": "SIX",
  "dbShow": "SIX the Musical",
  "scores": {
   "Romantic": 5,
   "Loyal": 5,
   "Principled": 4,
   "Dramatic": 3
  },
  "line": "You are the kindest person in the room, and you mean every bit of it.",
  "nudge": -0.0577
 },
 {
  "role": "Anna of Cleves",
  "show": "SIX",
  "dbShow": "SIX the Musical",
  "scores": {
   "Dry wit": 5,
   "Mischievous": 4,
   "Ambitious": 3,
   "Daring": 3
  },
  "line": "You got out with the house and the money, and you have never once been sorry.",
  "nudge": 0.065
 },
 {
  "role": "Katherine Howard",
  "show": "SIX",
  "dbShow": "SIX the Musical",
  "scores": {
   "Mischievous": 5,
   "Romantic": 4,
   "Daring": 3,
   "Dramatic": 3
  },
  "line": "You are pure sparkle, and you never let a mood stay down for long.",
  "nudge": -0.2026
 },
 {
  "role": "Catherine Parr",
  "show": "SIX",
  "dbShow": "SIX the Musical",
  "scores": {
   "Principled": 5,
   "Ambitious": 4,
   "Loyal": 4,
   "Dry wit": 3,
   "Romantic": 3
  },
  "line": "You are the one who reads the manual, and you somehow end up running the whole thing.",
  "nudge": -0.1146
 },
 {
  "role": "Jean Valjean",
  "show": "Les Misérables",
  "dbShow": "Les Misérables",
  "scores": {
   "Principled": 5,
   "Loyal": 4,
   "Daring": 3,
   "Dramatic": 3
  },
  "line": "You decided to be better, and then you were, repeatedly, at great cost.",
  "nudge": 0.1442
 },
 {
  "role": "Javert",
  "show": "Les Misérables",
  "dbShow": "Les Misérables",
  "scores": {
   "Principled": 5,
   "Ruthless": 4,
   "Dramatic": 4,
   "Ambitious": 3
  },
  "line": "The rules are the rules, and you do not bend. Eventually something has to give.",
  "nudge": -0.1237
 },
 {
  "role": "Éponine",
  "show": "Les Misérables",
  "dbShow": "Les Misérables",
  "scores": {
   "Romantic": 5,
   "Loyal": 5,
   "Daring": 3,
   "Dry wit": 3
  },
  "line": "You are the friend who never said a word about it, and everyone you helped should have noticed.",
  "nudge": -0.079
 },
 {
  "role": "Madame Thénardier",
  "show": "Les Misérables",
  "dbShow": "Les Misérables",
  "scores": {
   "Mischievous": 5,
   "Dry wit": 5,
   "Ruthless": 4,
   "Ambitious": 4,
   "Dramatic": 4
  },
  "line": "Everyone is a customer, and you are always, always selling something.",
  "nudge": -0.0057
 },
 {
  "role": "The Phantom",
  "show": "The Phantom of the Opera",
  "dbShow": "The Phantom of the Opera",
  "scores": {
   "Dramatic": 5,
   "Romantic": 4,
   "Ruthless": 4,
   "Ambitious": 3
  },
  "line": "You have a flair for the grand entrance, and the grand exit, and all the lighting in between.",
  "nudge": -0.2381
 },
 {
  "role": "Christine Daaé",
  "show": "The Phantom of the Opera",
  "dbShow": "The Phantom of the Opera",
  "scores": {
   "Romantic": 4,
   "Loyal": 4,
   "Daring": 3,
   "Dramatic": 3,
   "Principled": 3
  },
  "line": "You are far braver than you seem, and you have a better voice than you let on.",
  "nudge": 0.0634
 },
 {
  "role": "Carlotta Giudicelli",
  "show": "The Phantom of the Opera",
  "dbShow": "The Phantom of the Opera",
  "scores": {
   "Dramatic": 5,
   "Ambitious": 5,
   "Dry wit": 3,
   "Mischievous": 3,
   "Ruthless": 3
  },
  "line": "You are the star, you know it, and heaven help whoever disagrees.",
  "nudge": 0.0607
 },
 {
  "role": "Matilda",
  "show": "Matilda",
  "dbShow": "Matilda The Musical",
  "scores": {
   "Dry wit": 5,
   "Principled": 5,
   "Daring": 4,
   "Mischievous": 4,
   "Loyal": 3
  },
  "line": "You read the small print, and you have already planned your revenge in three clean steps.",
  "nudge": 0.0296
 },
 {
  "role": "Miss Trunchbull",
  "show": "Matilda",
  "dbShow": "Matilda The Musical",
  "scores": {
   "Ruthless": 5,
   "Dramatic": 5,
   "Ambitious": 3,
   "Dry wit": 2
  },
  "line": "Your idea of fair is that things are done your way, at your volume.",
  "nudge": -0.0462
 },
 {
  "role": "Miss Honey",
  "show": "Matilda",
  "dbShow": "Matilda The Musical",
  "scores": {
   "Loyal": 5,
   "Principled": 5,
   "Romantic": 3,
   "Daring": 2
  },
  "line": "You are the kindest person in the building, and braver than you realise.",
  "nudge": 0.0253
 },
 {
  "role": "Donna Sheridan",
  "show": "Mamma Mia!",
  "dbShow": "Mamma Mia!",
  "scores": {
   "Loyal": 5,
   "Daring": 4,
   "Dramatic": 4,
   "Romantic": 4,
   "Dry wit": 4
  },
  "line": "You ran a taverna single-handed. The past turned up regardless, and you handled it with a dance.",
  "nudge": -0.0232
 },
 {
  "role": "Tanya",
  "show": "Mamma Mia!",
  "dbShow": "Mamma Mia!",
  "scores": {
   "Dry wit": 5,
   "Mischievous": 4,
   "Dramatic": 4,
   "Daring": 4
  },
  "line": "You have been married more than once, and you have more style than the whole island combined.",
  "nudge": 0.028
 },
 {
  "role": "Rosie",
  "show": "Mamma Mia!",
  "dbShow": "Mamma Mia!",
  "scores": {
   "Dry wit": 5,
   "Mischievous": 5,
   "Loyal": 4,
   "Daring": 3
  },
  "line": "You say what everyone else is thinking, and you keep the party going.",
  "nudge": 0.018
 },
 {
  "role": "Hades",
  "show": "Hadestown",
  "dbShow": "Hadestown",
  "scores": {
   "Ruthless": 5,
   "Ambitious": 4,
   "Dry wit": 3,
   "Dramatic": 3
  },
  "line": "You built the whole place and you run it your way. Working conditions are somebody else's department.",
  "nudge": -0.0827
 },
 {
  "role": "Persephone",
  "show": "Hadestown",
  "dbShow": "Hadestown",
  "scores": {
   "Mischievous": 5,
   "Romantic": 4,
   "Dramatic": 4,
   "Daring": 4,
   "Dry wit": 3
  },
  "line": "You are the party, and the party is wherever you say it is. The seasons have opinions about that.",
  "nudge": -0.1046
 },
 {
  "role": "Orpheus",
  "show": "Hadestown",
  "dbShow": "Hadestown",
  "scores": {
   "Romantic": 5,
   "Loyal": 4,
   "Daring": 3,
   "Dramatic": 3,
   "Principled": 3
  },
  "line": "You will write the song and walk the whole road, and you will absolutely look back to check.",
  "nudge": 0.0067
 },
 {
  "role": "Beetlejuice",
  "show": "Beetlejuice",
  "dbShow": "Beetlejuice: The Musical",
  "scores": {
   "Mischievous": 5,
   "Dramatic": 5,
   "Dry wit": 5,
   "Daring": 4,
   "Ambitious": 3
  },
  "line": "You treat the fourth wall as a suggestion. Chaos is a personality, and you committed early.",
  "nudge": 0.1235
 },
 {
  "role": "Lydia Deetz",
  "show": "Beetlejuice",
  "dbShow": "Beetlejuice: The Musical",
  "scores": {
   "Dry wit": 4,
   "Principled": 3,
   "Daring": 3,
   "Dramatic": 3,
   "Loyal": 3
  },
  "line": "You wear black, you say what you think, and you are quietly the only sensible one in the house.",
  "nudge": 0.1175
 },
 {
  "role": "Delia Deetz",
  "show": "Beetlejuice",
  "dbShow": "Beetlejuice: The Musical",
  "scores": {
   "Ambitious": 5,
   "Dramatic": 5,
   "Mischievous": 3,
   "Dry wit": 3
  },
  "line": "You have a vision, a lot of sculpture and zero intention of being told no.",
  "nudge": 0.1746
 },
 {
  "role": "Satine",
  "show": "Moulin Rouge!",
  "dbShow": "Moulin Rouge! The Musical",
  "scores": {
   "Dramatic": 5,
   "Ambitious": 4,
   "Romantic": 4,
   "Daring": 4,
   "Loyal": 3
  },
  "line": "You are the sparkle on the poster and the person doing the sums behind it.",
  "nudge": 0.0268
 },
 {
  "role": "Harold Zidler",
  "show": "Moulin Rouge!",
  "dbShow": "Moulin Rouge! The Musical",
  "scores": {
   "Dramatic": 5,
   "Ambitious": 4,
   "Mischievous": 4,
   "Dry wit": 4,
   "Loyal": 3
  },
  "line": "You are the host, the manager and the whole nightclub in one waistcoat. The show must go on, and you are paying for it.",
  "nudge": 0.1879
 },
 {
  "role": "The Duke",
  "show": "Moulin Rouge!",
  "dbShow": "Moulin Rouge! The Musical",
  "scores": {
   "Ambitious": 5,
   "Ruthless": 5,
   "Dramatic": 3,
   "Dry wit": 2
  },
  "line": "You are used to getting what you pay for. Love, annoyingly, does not take cards.",
  "nudge": -0.141
 },
 {
  "role": "The Witch",
  "show": "Into the Woods",
  "dbShow": "Into the Woods",
  "scores": {
   "Dramatic": 5,
   "Dry wit": 4,
   "Loyal": 4,
   "Ruthless": 3,
   "Principled": 3,
   "Daring": 3
  },
  "line": "You tell everyone the truth they did not want, then you fix it, and you would like a thank you.",
  "nudge": 0.1132
 },
 {
  "role": "The Baker's Wife",
  "show": "Into the Woods",
  "dbShow": "Into the Woods",
  "scores": {
   "Ambitious": 4,
   "Daring": 4,
   "Loyal": 4,
   "Dry wit": 3,
   "Romantic": 3
  },
  "line": "You are the one who actually gets things done. The plan was somebody else's problem, so you made your own.",
  "nudge": 0.0265
 },
 {
  "role": "Cinderella's Prince",
  "show": "Into the Woods",
  "dbShow": "Into the Woods",
  "scores": {
   "Romantic": 5,
   "Dramatic": 4,
   "Mischievous": 3,
   "Dry wit": 3,
   "Ambitious": 2
  },
  "line": "You are charming, very well tailored, and you have never stayed in one place for long.",
  "nudge": -0.1462
 },
 {
  "role": "Judas",
  "show": "Jesus Christ Superstar",
  "dbShow": "Jesus Christ Superstar",
  "scores": {
   "Principled": 5,
   "Dramatic": 5,
   "Loyal": 4,
   "Daring": 3
  },
  "line": "You say the awkward thing out loud, then say it again. You are right, and it is going to cost you.",
  "nudge": 0.0995
 },
 {
  "role": "Mary Magdalene",
  "show": "Jesus Christ Superstar",
  "dbShow": "Jesus Christ Superstar",
  "scores": {
   "Loyal": 5,
   "Romantic": 4,
   "Principled": 4,
   "Dramatic": 3
  },
  "line": "You are the calm one in a room full of loud people, and the only one who remembers everyone's name.",
  "nudge": -0.039
 },
 {
  "role": "Herod",
  "show": "Jesus Christ Superstar",
  "dbShow": "Jesus Christ Superstar",
  "scores": {
   "Dramatic": 5,
   "Dry wit": 5,
   "Mischievous": 4,
   "Ruthless": 3,
   "Ambitious": 3
  },
  "line": "You treat every conversation as a cabaret turn. The throne is a lovely prop, and you are very pleased with it.",
  "nudge": 0.0792
 },
 {
  "role": "Fagin",
  "show": "Oliver!",
  "dbShow": "Oliver!",
  "scores": {
   "Mischievous": 5,
   "Dry wit": 5,
   "Dramatic": 4,
   "Ambitious": 3,
   "Loyal": 3
  },
  "line": "You will talk your way out of anything. You are always reviewing the situation, and you absolutely know it.",
  "nudge": 0.1527
 },
 {
  "role": "Nancy",
  "show": "Oliver!",
  "dbShow": "Oliver!",
  "scores": {
   "Loyal": 5,
   "Daring": 4,
   "Dramatic": 4,
   "Romantic": 4,
   "Principled": 4
  },
  "line": "You look after everyone, you take the hit, and you do it all with a song.",
  "nudge": 0.0864
 },
 {
  "role": "The Artful Dodger",
  "show": "Oliver!",
  "dbShow": "Oliver!",
  "scores": {
   "Mischievous": 5,
   "Dry wit": 5,
   "Daring": 4,
   "Ambitious": 3
  },
  "line": "You can get into anywhere, talk your way out of anything and be home for tea. Check your pockets.",
  "nudge": 0.0429
 },
 {
  "role": "Harry Potter",
  "show": "Harry Potter and the Cursed Child",
  "dbShow": "Harry Potter and the Cursed Child",
  "scores": {
   "Loyal": 4,
   "Principled": 4,
   "Daring": 4,
   "Dramatic": 2
  },
  "line": "You have saved the world before breakfast, and you still cannot work out how to talk to your own family.",
  "nudge": 0.181
 },
 {
  "role": "Hermione Granger",
  "show": "Harry Potter and the Cursed Child",
  "dbShow": "Harry Potter and the Cursed Child",
  "scores": {
   "Principled": 5,
   "Loyal": 5,
   "Ambitious": 4,
   "Dry wit": 3,
   "Daring": 3
  },
  "line": "You read the book, you did the research, you have a plan B, and plan C is laminated.",
  "nudge": 0.07
 },
 {
  "role": "Draco Malfoy",
  "show": "Harry Potter and the Cursed Child",
  "dbShow": "Harry Potter and the Cursed Child",
  "scores": {
   "Dry wit": 4,
   "Ambitious": 4,
   "Loyal": 3,
   "Dramatic": 3,
   "Principled": 3
  },
  "line": "You have a lot to prove, a very good coat and a very good eyebrow. Underneath, you are better than you let on.",
  "nudge": 0.1325
 },
 {
  "role": "Mark",
  "show": "RENT",
  "dbShow": "RENT",
  "scores": {
   "Loyal": 4,
   "Dry wit": 4,
   "Principled": 3,
   "Romantic": 2
  },
  "line": "You film everything and say very little. Behind every great band is somebody holding the camera.",
  "nudge": -0.0573
 },
 {
  "role": "Mimi",
  "show": "RENT",
  "dbShow": "RENT",
  "scores": {
   "Daring": 5,
   "Romantic": 4,
   "Dramatic": 4,
   "Mischievous": 3
  },
  "line": "You live for tonight, you never ask permission, and you are always looking for a light.",
  "nudge": -0.1506
 },
 {
  "role": "Angel",
  "show": "RENT",
  "dbShow": "RENT",
  "scores": {
   "Loyal": 5,
   "Dramatic": 5,
   "Romantic": 4,
   "Mischievous": 4,
   "Principled": 3
  },
  "line": "You walk in and the whole room perks up. You make friends the way other people make small talk.",
  "nudge": -0.111
 },
 {
  "role": "Elder Price",
  "show": "The Book of Mormon",
  "dbShow": "The Book of Mormon",
  "scores": {
   "Ambitious": 5,
   "Dramatic": 4,
   "Principled": 3,
   "Daring": 2
  },
  "line": "You have a five-year plan, a perfect smile, and no plan for it going wrong. It will go wrong.",
  "nudge": -0.0067
 },
 {
  "role": "Elder Cunningham",
  "show": "The Book of Mormon",
  "dbShow": "The Book of Mormon",
  "scores": {
   "Mischievous": 5,
   "Loyal": 4,
   "Dramatic": 3,
   "Daring": 3
  },
  "line": "You make it up as you go along, and somehow you are the one who gets through to people.",
  "nudge": -0.1338
 },
 {
  "role": "Nabulungi",
  "show": "The Book of Mormon",
  "dbShow": "The Book of Mormon",
  "scores": {
   "Romantic": 4,
   "Daring": 4,
   "Principled": 4,
   "Loyal": 4,
   "Ambitious": 3
  },
  "line": "You believe in a better place, and you are willing to go and find it yourself.",
  "nudge": -0.0055
 },
 {
  "role": "Miranda Priestly",
  "show": "The Devil Wears Prada",
  "dbShow": "The Devil Wears Prada",
  "scores": {
   "Ruthless": 5,
   "Ambitious": 5,
   "Dry wit": 5,
   "Dramatic": 3
  },
  "line": "You do not shout, because you do not need to. One raised eyebrow clears the room.",
  "nudge": -0.0614
 },
 {
  "role": "Andy",
  "show": "The Devil Wears Prada",
  "dbShow": "The Devil Wears Prada",
  "scores": {
   "Principled": 4,
   "Ambitious": 3,
   "Dry wit": 3,
   "Loyal": 3,
   "Daring": 3
  },
  "line": "You came for the job, stayed for the skills, and are still working out who you want to be at the end of it.",
  "nudge": 0.1152
 },
 {
  "role": "Emily",
  "show": "The Devil Wears Prada",
  "dbShow": "The Devil Wears Prada",
  "scores": {
   "Ambitious": 4,
   "Dramatic": 4,
   "Dry wit": 4,
   "Loyal": 3,
   "Ruthless": 2
  },
  "line": "You run the whole office on caffeine and spite, and you would do it all again for a trip to Paris.",
  "nudge": 0.0745
 },
 {
  "role": "The Emcee",
  "show": "Cabaret",
  "dbShow": "Cabaret",
  "scores": {
   "Mischievous": 5,
   "Dramatic": 5,
   "Dry wit": 5,
   "Daring": 4,
   "Ruthless": 2
  },
  "line": "You have a smile that never moves, a joke that always lands, and an eye on what is really going on.",
  "nudge": -0.0084
 },
 {
  "role": "Sally Bowles",
  "show": "Cabaret",
  "dbShow": "Cabaret",
  "scores": {
   "Dramatic": 5,
   "Ambitious": 4,
   "Daring": 4,
   "Romantic": 4,
   "Mischievous": 3
  },
  "line": "You live as if tomorrow is optional, with a good frock and no questions about the rent.",
  "nudge": -0.0392
 },
 {
  "role": "Princeton",
  "show": "Avenue Q",
  "dbShow": "Avenue Q",
  "scores": {
   "Ambitious": 4,
   "Daring": 3,
   "Romantic": 3,
   "Principled": 2
  },
  "line": "You have a degree, a lot of ambition and no idea what to do with it. A purpose is on its way.",
  "nudge": -0.124
 },
 {
  "role": "Kate Monster",
  "show": "Avenue Q",
  "dbShow": "Avenue Q",
  "scores": {
   "Loyal": 5,
   "Romantic": 4,
   "Principled": 4,
   "Dry wit": 3
  },
  "line": "You are the nicest person on the street, and you are very tired of being asked to wait.",
  "nudge": -0.0675
 },
 {
  "role": "Billy",
  "show": "Billy Elliot",
  "dbShow": "Billy Elliot the Musical",
  "scores": {
   "Daring": 5,
   "Dramatic": 4,
   "Principled": 3,
   "Loyal": 3,
   "Romantic": 2
  },
  "line": "Everyone said no. You danced anyway, and you are still quietly furious about it.",
  "nudge": 0.0496,
  "exact": true
 },
 {
  "role": "Mrs Wilkinson",
  "show": "Billy Elliot",
  "dbShow": "Billy Elliot the Musical",
  "scores": {
   "Dry wit": 5,
   "Loyal": 4,
   "Principled": 4,
   "Ambitious": 3,
   "Dramatic": 3
  },
  "line": "You tell people to stop mumbling, smoke through a pep talk, and secretly you are their biggest fan.",
  "nudge": 0.1189
 },
 {
  "role": "Katniss Everdeen",
  "show": "The Hunger Games",
  "dbShow": "The Hunger Games: On Stage",
  "scores": {
   "Daring": 5,
   "Loyal": 5,
   "Principled": 4,
   "Ruthless": 2
  },
  "line": "You did not ask to be the symbol. You volunteered for someone else and ended up leading a revolution.",
  "nudge": 0.0841
 },
 {
  "role": "Effie Trinket",
  "show": "The Hunger Games",
  "dbShow": "The Hunger Games: On Stage",
  "scores": {
   "Dramatic": 5,
   "Ambitious": 4,
   "Loyal": 4,
   "Principled": 3,
   "Dry wit": 3
  },
  "line": "You have a timetable, a firm view on manners, and a surprising amount of steel underneath it.",
  "nudge": 0.1065
 },
 {
  "role": "Paddington",
  "show": "Paddington",
  "dbShow": "Paddington The Musical",
  "scores": {
   "Principled": 5,
   "Loyal": 5,
   "Mischievous": 3,
   "Daring": 3
  },
  "line": "You are polite to everyone, you mean it, and you keep a marmalade sandwich for emergencies.",
  "nudge": 0.004
 },
 {
  "role": "Mrs Bird",
  "show": "Paddington",
  "dbShow": "Paddington The Musical",
  "scores": {
   "Dry wit": 5,
   "Loyal": 4,
   "Principled": 4,
   "Dramatic": 3
  },
  "line": "You complain about everything and make sure everyone is fed, rested and fine. They know.",
  "nudge": 0.0763
 },
 {
  "role": "Millicent Clyde",
  "show": "Paddington",
  "dbShow": "Paddington The Musical",
  "scores": {
   "Ruthless": 5,
   "Daring": 4,
   "Dramatic": 4,
   "Ambitious": 3,
   "Dry wit": 2
  },
  "line": "You want a rare specimen and you are used to getting your way. Politeness is something other people do.",
  "nudge": -0.1557
 },
 {
  "role": "Mollie Ralston",
  "show": "The Mousetrap",
  "dbShow": "The Mousetrap",
  "scores": {
   "Loyal": 4,
   "Principled": 4,
   "Romantic": 3,
   "Dry wit": 2
  },
  "line": "You run a perfectly lovely guesthouse, your tea is excellent, and you are absolutely not telling anyone everything you know.",
  "nudge": -0.0483
 },
 {
  "role": "Mrs Boyle",
  "show": "The Mousetrap",
  "dbShow": "The Mousetrap",
  "scores": {
   "Dry wit": 5,
   "Dramatic": 3,
   "Principled": 3,
   "Ruthless": 2
  },
  "line": "You send the soup back, rate the guesthouse out loud and make sure everyone hears. You are, undeniably, the one the whole room remembers.",
  "nudge": -0.0582
 },
 {
  "role": "Mr Paravicini",
  "show": "The Mousetrap",
  "dbShow": "The Mousetrap",
  "scores": {
   "Mischievous": 5,
   "Dramatic": 5,
   "Dry wit": 4,
   "Daring": 3
  },
  "line": "You arrive in a snowstorm with no luggage and a dazzling smile. Nobody ever quite works out who you are.",
  "nudge": 0.0307
 },
 {
  "role": "Chris",
  "show": "The Play That Goes Wrong",
  "dbShow": "The Play That Goes Wrong",
  "scores": {
   "Ambitious": 5,
   "Dramatic": 4,
   "Loyal": 3,
   "Principled": 2
  },
  "line": "You have a vision, plenty of faith, and no idea the set is falling down behind you. It will be magnificent.",
  "nudge": -0.0441
 },
 {
  "role": "Sandra",
  "show": "The Play That Goes Wrong",
  "dbShow": "The Play That Goes Wrong",
  "scores": {
   "Dramatic": 5,
   "Ambitious": 4,
   "Romantic": 3,
   "Daring": 3
  },
  "line": "You were given the lead, and you are giving it everything, including the furniture. It is a lot, and it is brilliant.",
  "nudge": 0.003
 },
 {
  "role": "Annie",
  "show": "The Play That Goes Wrong",
  "dbShow": "The Play That Goes Wrong",
  "scores": {
   "Daring": 4,
   "Dramatic": 4,
   "Ambitious": 3,
   "Loyal": 3
  },
  "line": "You were told to stay in the wings. Then you walked on in the wrong costume and became the best thing in the show.",
  "nudge": 0.0659
 },
 {
  "role": "Max",
  "show": "The Play That Goes Wrong",
  "dbShow": "The Play That Goes Wrong",
  "scores": {
   "Dramatic": 5,
   "Mischievous": 4,
   "Ambitious": 4,
   "Daring": 3
  },
  "line": "You do not do subtle. You have found the audience, made eye contact, and you are not leaving until they clap.",
  "nudge": -0.0247
 },
 {
  "role": "Rose",
  "show": "Titanique",
  "dbShow": "Titanique",
  "scores": {
   "Romantic": 5,
   "Dramatic": 5,
   "Daring": 4,
   "Dry wit": 2
  },
  "line": "You feel everything at full volume, then find a key change for it. Your heart will go on, whether or not the ship does.",
  "nudge": -0.1319
 },
 {
  "role": "Cal",
  "show": "Titanique",
  "dbShow": "Titanique",
  "scores": {
   "Ambitious": 5,
   "Dramatic": 4,
   "Dry wit": 4,
   "Ruthless": 3
  },
  "line": "You have a title, a plan and an excellent coat. You assume the rest of the ship has been arranged for your convenience.",
  "nudge": 0.0686
 },
 {
  "role": "The Iceberg",
  "show": "Titanique",
  "dbShow": "Titanique",
  "scores": {
   "Dry wit": 5,
   "Dramatic": 4,
   "Ruthless": 3,
   "Mischievous": 3
  },
  "line": "You are cool, calm and utterly immovable, and you always turn up at the worst possible moment. It's nothing personal.",
  "nudge": -0.0206
 },
 {
  "role": "Judith Bliss",
  "show": "Hay Fever",
  "dbShow": "Hay Fever",
  "scores": {
   "Dramatic": 5,
   "Dry wit": 4,
   "Mischievous": 4,
   "Ambitious": 3,
   "Loyal": 3
  },
  "line": "You are not being dramatic, you are rehearsing. At breakfast, in the hall and during other people's conversations.",
  "nudge": 0.1605
 },
 {
  "role": "Myra Arundel",
  "show": "Hay Fever",
  "dbShow": "Hay Fever",
  "scores": {
   "Mischievous": 4,
   "Ambitious": 4,
   "Dry wit": 4,
   "Daring": 4,
   "Romantic": 3
  },
  "line": "You arrive for a quiet weekend with a cigarette holder, a lovely dress and a very clear idea of what you want. The household is not ready.",
  "nudge": 0.0154
 },
 {
  "role": "Beatrice",
  "show": "Much Ado About Nothing",
  "dbShow": "Much Ado About Nothing",
  "scores": {
   "Dry wit": 5,
   "Loyal": 4,
   "Principled": 4,
   "Romantic": 4,
   "Daring": 3
  },
  "line": "You say the sharpest thing in the room, then wonder why nobody dares to ask you to dance. (Someone does. You argue.)",
  "nudge": -0.0791
 },
 {
  "role": "Benedick",
  "show": "Much Ado About Nothing",
  "dbShow": "Much Ado About Nothing",
  "scores": {
   "Dry wit": 5,
   "Mischievous": 4,
   "Romantic": 3,
   "Loyal": 3,
   "Dramatic": 3
  },
  "line": "You have sworn off love in public, in writing and with total conviction. Your friends are already placing bets.",
  "nudge": -0.0584
 },
 {
  "role": "Rosalind",
  "show": "As You Like It",
  "dbShow": "As You Like It",
  "scores": {
   "Daring": 5,
   "Romantic": 4,
   "Dry wit": 4,
   "Mischievous": 4,
   "Loyal": 3
  },
  "line": "You walked into the forest in a disguise and ended up running the place, including your own love life. Everyone is following your lead.",
  "nudge": -0.0751
 },
 {
  "role": "Touchstone",
  "show": "As You Like It",
  "dbShow": "As You Like It",
  "scores": {
   "Dry wit": 5,
   "Mischievous": 5,
   "Dramatic": 3,
   "Loyal": 2
  },
  "line": "You are the only one who has noticed everyone is being ridiculous, and you intend to say so, with a lot of jokes.",
  "nudge": 0.0486
 },
 {
  "role": "Satsuki",
  "show": "My Neighbour Totoro",
  "dbShow": "My Neighbour Totoro",
  "scores": {
   "Loyal": 5,
   "Principled": 4,
   "Daring": 3,
   "Ambitious": 2
  },
  "line": "You are the one who packs the lunch, checks the map and looks after everyone, and you do it brilliantly while quietly panicking.",
  "nudge": 0.0387
 },
 {
  "role": "Mei",
  "show": "My Neighbour Totoro",
  "dbShow": "My Neighbour Totoro",
  "scores": {
   "Daring": 5,
   "Mischievous": 4,
   "Loyal": 3,
   "Romantic": 2
  },
  "line": "You are fearless, curious and entirely certain that the enormous furry creature in the garden is a friend. You are usually right.",
  "nudge": -0.1335
 },
 {
  "role": "Ewen Montagu",
  "show": "Operation Mincemeat",
  "dbShow": "Operation Mincemeat",
  "scores": {
   "Ambitious": 5,
   "Dry wit": 4,
   "Dramatic": 3,
   "Principled": 3,
   "Ruthless": 3
  },
  "line": "You have a magnificent plan, a very smooth voice and total confidence in the details. The details are, as ever, someone else's job.",
  "nudge": -0.0318
 },
 {
  "role": "Hester Leggatt",
  "show": "Operation Mincemeat",
  "dbShow": "Operation Mincemeat",
  "scores": {
   "Ambitious": 4,
   "Loyal": 4,
   "Dry wit": 4,
   "Principled": 4,
   "Daring": 3
  },
  "line": "You are the one who actually makes it all work, and you have been underestimated all your life. That is going to be very satisfying.",
  "nudge": 0.1206
 },
 {
  "role": "Vivian Ward",
  "show": "Pretty Woman",
  "dbShow": "Pretty Woman The Musical",
  "scores": {
   "Daring": 5,
   "Romantic": 4,
   "Ambitious": 4,
   "Dry wit": 4,
   "Mischievous": 3
  },
  "line": "You walked in with no plan, and the whole room has been rearranged around you. It turns out you were right.",
  "nudge": -0.0201
 },
 {
  "role": "Edward Lewis",
  "show": "Pretty Woman",
  "dbShow": "Pretty Woman The Musical",
  "scores": {
   "Ambitious": 5,
   "Ruthless": 3,
   "Romantic": 3,
   "Principled": 3,
   "Dry wit": 2
  },
  "line": "You have a plane, a spreadsheet and no idea how to take an afternoon off. It will take a lot of champagne and one very long evening.",
  "nudge": -0.3
 },
 {
  "role": "Romeo",
  "show": "Romeo & Juliet",
  "dbShow": "Romeo & Juliet",
  "scores": {
   "Romantic": 5,
   "Daring": 4,
   "Dramatic": 4,
   "Loyal": 4,
   "Principled": 2
  },
  "line": "You fall in love before you have finished the sentence, and you do everything at a sprint. The planning department has asked to speak to you.",
  "nudge": 0.0181
 },
 {
  "role": "Juliet",
  "show": "Romeo & Juliet",
  "dbShow": "Romeo & Juliet",
  "scores": {
   "Romantic": 5,
   "Daring": 5,
   "Loyal": 4,
   "Dramatic": 4,
   "Principled": 3
  },
  "line": "You decided who you loved, ignored all the advice, and made a plan involving a very small bottle. Brave, yes. Please read the label.",
  "nudge": 0.0406
 },
 {
  "role": "Rosencrantz",
  "show": "Rosencrantz and Guildenstern Are Dead",
  "dbShow": "Rosencrantz and Guildenstern Are Dead",
  "scores": {
   "Loyal": 5,
   "Mischievous": 3,
   "Dry wit": 3,
   "Romantic": 2
  },
  "line": "You are loyal, easygoing, and mildly worried that the coin keeps coming up heads. It does seem like a lot.",
  "nudge": -0.113
 },
 {
  "role": "Guildenstern",
  "show": "Rosencrantz and Guildenstern Are Dead",
  "dbShow": "Rosencrantz and Guildenstern Are Dead",
  "scores": {
   "Dry wit": 5,
   "Principled": 4,
   "Loyal": 4,
   "Dramatic": 3,
   "Ambitious": 2
  },
  "line": "You have the questions, the theories and a growing sense that nobody has told you what is going on. You are right about that.",
  "nudge": 0.1042
 },
 {
  "role": "Lyubov Ranevskaya",
  "show": "The Cherry Orchard",
  "dbShow": "The Cherry Orchard",
  "scores": {
   "Romantic": 5,
   "Dramatic": 5,
   "Loyal": 3,
   "Mischievous": 3
  },
  "line": "You will throw a party you cannot afford, forgive everyone for everything, and avoid reading the invoice until it is on fire.",
  "nudge": -0.1663
 },
 {
  "role": "Varya",
  "show": "The Cherry Orchard",
  "dbShow": "The Cherry Orchard",
  "scores": {
   "Loyal": 5,
   "Principled": 5,
   "Ambitious": 3,
   "Dry wit": 3,
   "Daring": 2
  },
  "line": "You keep the entire estate running, you are never thanked, and you would still do it again. Please sit down for a minute.",
  "nudge": 0.0471
 },
 {
  "role": "Baloo",
  "show": "The Jungle Book",
  "dbShow": "The Jungle Book",
  "scores": {
   "Loyal": 5,
   "Mischievous": 4,
   "Dry wit": 3,
   "Daring": 3,
   "Principled": 3
  },
  "line": "You take life one honey-covered afternoon at a time, and somehow you are the one who is there when it matters.",
  "nudge": 0.0339
 },
 {
  "role": "Shere Khan",
  "show": "The Jungle Book",
  "dbShow": "The Jungle Book",
  "scores": {
   "Ruthless": 5,
   "Dramatic": 5,
   "Ambitious": 4,
   "Dry wit": 3
  },
  "line": "You have a presence, a grudge and a very good entrance. The jungle goes quiet when you walk in, and you like it that way.",
  "nudge": 0.0043
 },
 {
  "role": "Gerd Wiesler",
  "show": "The Lives of Others",
  "dbShow": "The Lives of Others",
  "scores": {
   "Principled": 5,
   "Loyal": 4,
   "Daring": 3,
   "Dry wit": 2
  },
  "line": "You listen to everything, say very little, and have a quiet conscience that eventually becomes impossible to ignore.",
  "nudge": 0.1377
 },
 {
  "role": "Christa-Maria Sieland",
  "show": "The Lives of Others",
  "dbShow": "The Lives of Others",
  "scores": {
   "Dramatic": 4,
   "Romantic": 4,
   "Loyal": 4,
   "Daring": 3,
   "Principled": 3
  },
  "line": "You are the star everyone wants a piece of. You are working out which parts of you are actually yours.",
  "nudge": 0.0418
 },
 {
  "role": "Henry Creel",
  "show": "Stranger Things: The First Shadow",
  "dbShow": "Stranger Things: The First Shadow",
  "scores": {
   "Ruthless": 5,
   "Ambitious": 4,
   "Mischievous": 3,
   "Dry wit": 3,
   "Dramatic": 2
  },
  "line": "You are polite, quiet and extremely good at hiding things. Nobody notices until the lights start to flicker.",
  "nudge": -0.1822
 },
 {
  "role": "Joyce Maldonado",
  "show": "Stranger Things: The First Shadow",
  "dbShow": "Stranger Things: The First Shadow",
  "scores": {
   "Daring": 4,
   "Loyal": 4,
   "Principled": 4,
   "Dry wit": 3
  },
  "line": "You noticed something was off before the adults did, refused to let it drop, and were right.",
  "nudge": 0.1895
 },
 {
  "role": "Hefina",
  "show": "Pride",
  "dbShow": "Pride",
  "scores": {
   "Principled": 5,
   "Loyal": 5,
   "Daring": 4,
   "Dry wit": 4,
   "Ambitious": 3,
   "Dramatic": 3
  },
  "line": "You run the village and its entire tea rota, and you decided to help in about thirty seconds. Nobody has ever said no to you.",
  "nudge": 0.1847
 },
 {
  "role": "Jonathan",
  "show": "Pride",
  "dbShow": "Pride",
  "scores": {
   "Dramatic": 5,
   "Romantic": 4,
   "Loyal": 4,
   "Dry wit": 4,
   "Mischievous": 3,
   "Principled": 3
  },
  "line": "You arrive with a flourish, an opinion about the curtains and a heart as large as the room. You are the one everyone remembers.",
  "nudge": -0.0651
 },
 {
  "role": "John Maynard Keynes",
  "show": "The Standard of Living",
  "dbShow": "The Standard of Living",
  "scores": {
   "Ambitious": 4,
   "Dry wit": 4,
   "Principled": 3,
   "Dramatic": 3,
   "Daring": 3
  },
  "line": "You have an economic theory for everything, including why you are late. It is a very persuasive theory.",
  "nudge": 0.1328
 },
 {
  "role": "Virginia Woolf",
  "show": "The Standard of Living",
  "dbShow": "The Standard of Living",
  "scores": {
   "Dry wit": 5,
   "Daring": 4,
   "Romantic": 3,
   "Principled": 3,
   "Dramatic": 3
  },
  "line": "You notice everything, you write it down, and you always have an opinion about the person who has just left the room.",
  "nudge": -0.1025
 },
 {
  "role": "Mary Todd Lincoln",
  "show": "Oh, Mary!",
  "dbShow": "Oh, Mary!",
  "scores": {
   "Dramatic": 5,
   "Ambitious": 5,
   "Daring": 4,
   "Mischievous": 4,
   "Dry wit": 3
  },
  "line": "You are a cabaret legend and a tragically unrecognised talent, according to you. The whole White House has heard about it.",
  "nudge": 0.1319
 },
 {
  "role": "Hamlet",
  "show": "Hamlet",
  "dbShow": "Hamlet",
  "scores": {
   "Dramatic": 5,
   "Dry wit": 5,
   "Principled": 4,
   "Loyal": 3,
   "Romantic": 2
  },
  "line": "You will think about it, then think about thinking about it. Eventually, in the fifth act, there will be action.",
  "nudge": -0.0114
 }
];